import axios from 'axios';
import constants from "../constants";
import {getHeaders} from './global';


function createWorkspace(payload){
    return axios.post(
        constants.API_BASE_URL + "workspaces/",
        payload,
        getHeaders()
    )
}

function getWorkspaces(){
    return axios.get(
        constants.API_BASE_URL + "workspaces/",
        getHeaders()
    )
}

function getWorkspace(workspace_id){
    return axios.get(
        constants.API_BASE_URL + "workspaces/" + workspace_id + "/",
        getHeaders()
    )
}

function updateWorkspace(workspace_id, payload){
    return axios.patch(
        constants.API_BASE_URL + "workspaces/" + workspace_id + "/",
        payload,
        getHeaders()
    )
}

function cancelWorkspaceInvitation(workspace_id, invitation_id){
    return axios.delete(
        constants.API_BASE_URL + "workspaces/" + workspace_id + "/invitations/" + invitation_id + "/",
        getHeaders()
    )
}

function createWorkspaceInvitation(workspace_id, email){
    return axios.post(
        constants.API_BASE_URL + "workspaces/" + workspace_id + "/invitations/",
        {"email": email},
        getHeaders()
    )
}

function removeMemberFromWorkspace(workspace_id, member_id){
    let headers = getHeaders();
    console.log(headers)
    headers["data"] = {"member": member_id}
    return axios.delete(
        constants.API_BASE_URL + "workspaces/" + workspace_id + "/members/",
        headers,
    )
}


export {
    createWorkspace,
    getWorkspaces,
    getWorkspace,
    updateWorkspace,
    cancelWorkspaceInvitation,
    createWorkspaceInvitation,
    removeMemberFromWorkspace,
}